import { render, staticRenderFns } from "./TemplateRegister.vue?vue&type=template&id=2c72d46e&scoped=true&lang=pug"
import script from "./TemplateRegister.vue?vue&type=script&lang=ts"
export * from "./TemplateRegister.vue?vue&type=script&lang=ts"
import style0 from "./TemplateRegister.vue?vue&type=style&index=0&id=2c72d46e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c72d46e",
  null
  
)

export default component.exports